import React from 'react'

export const DataConnectionContext = React.createContext({})


// let dataConnection = {
//     action,
//     loading, setLoading,
//     data, setData,
//     loader, setLoader,
//     id
// }